import { render, staticRenderFns } from "./CardMobileBasic.vue?vue&type=template&id=486e04de&scoped=true&"
import script from "./CardMobileBasic.vue?vue&type=script&lang=js&"
export * from "./CardMobileBasic.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileBasic.vue?vue&type=style&index=0&id=486e04de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e04de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
